// extracted by mini-css-extract-plugin
module.exports = {"currentPage":"approver-dashboard_currentPage__1Ddqm","paginationLinks":"approver-dashboard_paginationLinks__1GLRx","pagination":"approver-dashboard_pagination__3Y_UA"};